import { useMemo, useState } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { useAFBFunction } from "./useAFBFunction";
import { IconButton } from "@mui/material";
import { useDialog } from "@albo-ui/core";
import { Person, CreditCard, } from "@mui/icons-material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import moment from "moment";
moment.locale("es");

export const useAFBCustomerTable = (changeAlert: ChangeAlertCallbackType, changeWidgets, addWidget) => {
    const { handleCustomerList, handleCompanyCards, handleContactList } = useAFBFunction(changeAlert);
    const dialogCards = useDialog();
    const dialogAccount = useDialog();
    const dialogClabe = useDialog();

    const [data, setData] = useState([]);
    const [item, setItem] = useState(null);
    const [loading, setLoading] = useState(true);
    const [config, setConfig] = useState(null);

    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalDocuments, setTotalDocuments] = useState(0);

    const onOpenDialogAccount = () => {
        dialogAccount.openDialog();
    };
    const onOpenDialogClabe = () => {
        dialogClabe.openDialog();
    };
    
    const onCloseDialog = (type) => {
        switch (type) {
            case "account":
                dialogAccount.onClose();
                break;
            case "cards":
                setItem(null);
                dialogCards.onClose();
                break;
            case "clabe":
                dialogClabe.onClose();
                break;
            default:
                break;
        }
    };

    const saveData = async ({data, config}) => {
        let validate = Array.isArray(data?.content);
        setData(JSON.parse(JSON.stringify(validate ? data.content || [] : [data.content])));
        setTotalDocuments(data.pagination ? data.pagination["totalResults"] : 0);
        setConfig(JSON.parse(JSON.stringify(config)));
    };

    const getData = async (newPage = page, newPerPage = rowsPerPage) => {
        setLoading(true);
        let payload = {
            filters: {
                results_per_page: newPerPage,
                page_number: newPage,
            },
        };

        let resp = await handleCustomerList(payload);
        resp ? saveData(resp) : setData([]);
        setLoading(false);
    };

    const onHandleCardCount = async (ob) => {
        setLoading(true);
        let resp = await handleCompanyCards(ob);
        if (resp && resp["content"]) {
            setItem(resp["content"]);
            dialogCards.openDialog();
        } else {
            setItem(null);
        }
        setLoading(false);
    };

    const onHandleContactList = async (ob) => {
        setLoading(true);
        let payload = {
            find: ob,
            limit: 20,
            page: 1,
        };
        let resp = await handleContactList(payload);
        if (resp) {
            setLoading(false);
            return changeWidgets(JSON.parse(JSON.stringify(resp)));
        } else {
            setLoading(false);
        }
    };

    const onHandleOpenEmail = (customer) => {
        return addWidget('infoPersonal', customer.uuid, ["changeEmail"], customer.email);
    };

    const changePage = (action, page, rows = rowsPerPage) => {
        setPage(page + 1);
        getData(page + 1, rows);
    };
    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setRowsPerPage(JSON.parse(JSON.stringify(event.target.value)));
        changePage(null, 0, parseInt(event.target.value, 10));
    };

    const calculateColumns = useMemo(() => {
        const columns = [
            { cell: (row) => {
                    // eslint-disable-next-line jsx-a11y/anchor-is-valid
                    return <a href="#" onClick={onHandleOpenEmail.bind(this, row)} title="Ver más"><VisibilityIcon /></a>
                }, width: "5%", sortable: true
            },
            { selector: (row) => row['corporate_name'], name: 'Nombre', wrap: true, sortable: true, width: "21%" },
            { selector: (row) => row['cdate'], name: 'Fecha creación', wrap: true, sortable: true, width: "19%" },
            { selector: (row) => row['corporate_name'], name: 'Razón social', wrap: true, sortable: true, width: "19%" },
            { selector: (row) => row['phone'], name: 'Teléfono', wrap: true, sortable: true, width: "15%" },
            { selector: (row) => row['status'], name: 'Estatus', wrap: true, sortable: true, width: "10%" },
            { cell: (row) => {
                    return (
                        <div style={{ display: "flex" }}>
                            <IconButton title="Tarjetas" onClick={onHandleCardCount.bind(this, row.email)} >
                                <CreditCard />
                            </IconButton>
                            <IconButton title="Colaboradores" onClick={onHandleContactList.bind(this, row.email)} >
                                <Person />
                            </IconButton>           
                        </div>
                    );
                }, sortable: true, maxWidth: "9%"
            }
        ];

        return columns;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        data,
        item,
        config,
        loading,
        columns: calculateColumns,
        pagination: { page, rowsPerPage, totalDocuments },
        dialogAccount,
        dialogClabe,
        dialogCards,
        getData,
        changePage,
        handleChangeRowsPerPage,
        onOpenDialogAccount,
        onOpenDialogClabe,
        onCloseDialog
    };
};
